<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  watch: {
    '$route'(to, from) {
    }
  },
  created() {
    Object.getPrototypeOf(
      this.$options.components
    ).ElSelect.options.methods.handleFocus = (event) => {
    };
  },
  mounted() {
  }
}
</script>
<style>
  html, body{
    margin: 0;
    padding: 0;
    height: auto;
    overflow-x: hidden;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .el-select-dropdown__item{
    padding: 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue